/**
 * Stáhne soubor z dat ve formátu Blob.
 * @param blob Data ve formátu Blob.
 * @param fileName Název souboru.
 */
export function downloadFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none'; // Nepřidáváme do DOMu vizuálně
  a.href = url;
  a.setAttribute('download', fileName); // správný způsob zápisu
  document.body.appendChild(a); // Safari to potřebuje
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100); // oddálení pro kompatibilitu
}

/**
 * Stáhne připravený soubor s daným obsahem a typem.
 * @param content Obsah souboru.
 * @param type Typ souboru (např. 'text/plain', 'application/json').
 * @param name Název souboru (např. 'soubor.txt').
 */
export function downloadReadyFile(content: string, type: string, name: string) {
  const blob = new Blob([content], { type: type });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * Exportuje data jako PDF soubor.
 * @param data Data ve formátu Blob.
 * @param fileName Název souboru bez přípony.
 * @returns Výsledek funkce downloadFile.
 */
export const exportPdf = (data: Blob, fileName: string) => {
  return downloadFile(data, `${fileName}.pdf`);
};

/**
 * Exportuje data jako CSV soubor.
 * @param data Data ve formátu Blob.
 * @param fileName Název souboru bez přípony.
 * @returns Výsledek funkce downloadFile.
 */
export const exportCsv = (data: Blob, fileName: string) => {
  return downloadFile(data, `${fileName}.csv`);
};
